import { motion } from "framer-motion";
import styles from "./css/GlobalFooter.module.css";

export default function GlobalFooter() {
	return (
		<motion.footer
			className={styles.footer}
			initial={{ opacity: 0, y: 16 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ delay: 0.3, duration: 0.4, ease: "easeOut" }}
		>
			<span className={styles.text}>
				Creado por{" "}
				<a
					className={styles.author}
					href="https://github.com/jibleg"
					target="_blank"
					rel="noreferrer"
				>
					@jibleg
				</a>{" "}
				para CIEM Radiólogos &nbsp;·&nbsp; Copyright &copy; 2026
			</span>
		</motion.footer>
	);
}
